export interface IBaseColorsConfig {
    primary?: string;
    primaryHover?: string;
    primaryActive?: string;
    background?: string;
    surface?: string;
    dark?: string;
    textSecondary?: string;
}

// 1. Дефолтные базовые цвета
// const _baseColors = {
//     primary: '#03174C', // Основной акцент
//     primaryHover: '#64B5F1', // Основной hover
//     primaryActive: '#64B5F1', //
//     background: '#EEF1FB', // Общий фон страницы и модалок
//     surface: '#fff', // Карточки
//     dark: '#000000',
//     textSecondary: '#00000080',  // Неакцентный текст
// };

// 2. Функция обновления baseColors
 const updateBaseColors = (customColors: IBaseColorsConfig):IBaseColorsConfig => {
   return {
        primary: customColors?.primary ?? '#03174C', // Основной акцент
        primaryHover: customColors?.primaryHover ?? '#64B5F1', // Основной hover
        primaryActive: customColors?.primaryActive ?? '#64B5F1', //
        background: customColors?.background ?? '#EEF1FB', // Общий фон страницы и модалок
        surface: customColors?.surface ?? '#fff', // Карточки
        dark: customColors?.dark ?? '#000000',
        textSecondary: customColors?.textSecondary ?? '#00000080',  // Неакцентный текст
    };
};

export const getThemeStyles = (customColors: IBaseColorsConfig) => {
    const baseColors = updateBaseColors(customColors);
    return {
        borderRadius: {
            default: '16px',              // Например, карточки.
            round: '100px',              // Поля поиска, кнопки с полным скруглением.
        },
        colors: {
            primary: baseColors.primary, //	Основной акцент
            primaryHover: baseColors.primaryHover, //Основной hover
            primaryActive: baseColors.primaryActive, //
            background: baseColors.background, //Общий фон страницы и модалок
            surface: baseColors.surface, //Карточки
            textSecondary: baseColors.textSecondary,
            dark: baseColors.dark,


            lightBlue: '#64B5F1',
            blue: '#1761CC',
            middleBlue: '#1E3060',
            darkBlue: '#03174C',
            lightWhite: '#FFFFFF80',
            white: '#fff',
            // dark: '#000000',
            red: '#F84147',
            darkRed: '#B6252A',
            orange: '#FFA900',
            orangeDark: '#BB7C00',
            lightGrey: baseColors.textSecondary,
            grey: 'rgba(0, 0, 0, 0.50)',
            bodyColor: baseColors.background,

        },
        card: {
            bgColor: baseColors.surface,
            borderColor: baseColors.surface,
            hoverBorderColor: baseColors.surface,
            borderRadius: '16px',
            shadowPrimary: '0 0 0 transparent',
            shadowHover: '0px 4px 40px 0px rgba(3, 23, 76, 0.25)',
            textColor: baseColors.primary,
        },
        cardItem: {
            backgroundColor: baseColors.background,
            borderColor: '#03174C33',
            // border: '1px solid #03174C33',
            borderRadius: '16px',
            titleColor: baseColors.primary,

        },
        search: {
            borderRadius: '100px',
            borderColor: baseColors.primary,
            bgColor: 'white',
            textColor: baseColors.dark,
            suggestColor: baseColors.textSecondary,

        },
        button: {
            bgColor: baseColors.primary,
            hoverBgColor: baseColors.primaryHover,
            activeBgColor: baseColors.primaryActive,
            textColor: '#ffffff',
            borderRadius: '6px',
            padding: '10px',
            fontSize: 'clamp(16px, 2vw, 18px)',
            fontWeight: '500',
            shadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
        },
        fonts: {
            body: 'Montserrat, sans-serif',
            helvetica: 'Helvetica, sans-serif',
            monserrat: 'Montserrat, sans-serif'
        },

        container: {
            maxWidth: '1720px',
            padding: '0 10px'
        },

        breakpoints: {
            sm: `576px`,
            md: `768px`,
            lg: `992px`,
            xl: `1200px`,
            xxl: `1400px`,
        },
        filterSelectedTag: {
            bgColor: '#0000001A',
            hoverBorderColor: baseColors.primary,
            borderColor: '#0000001A',
            borderRadius: '100px',
        },
        price: {
            oldColor: 'rgba(0, 0, 0, 0.50)',
            defaultColor: baseColors.primary
        },
        dropdown: {
            borderRadius: '20px',
            borderColor: baseColors.dark,
            bgColor: 'transparent',
            bgColorOpen: 'white',
            textColor: baseColors.dark,
            textWeight: '500'
        }

    }
}
